import type { RouteRecordRaw } from 'vue-router';

/**
 * Routes for the account module
 */
export const accountRoutes: Array<RouteRecordRaw> = [
  {
    name: 'ProfileGroup',
    path: 'profile',
    component: () => import('@/views/private/account/profile/index.vue'),
    children: [
      {
        name: 'Company',
        path: 'company',
        component: () =>
          import('@/views/private/account/profile/MySubsidiary.vue'),
      },
      {
        name: 'BankAccount',
        path: 'bankAccount',
        component: () =>
          import('@/views/private/account/profile/BankDetails.vue'),
      },
      {
        name: 'Profile',
        path: 'me',
        component: () =>
          import('@/views/private/account/profile/MyProfile.vue'),
      },
      {
        name: 'Billing',
        path: 'billing',
        component: () =>
          import('@/views/private/account/profile/SubscriptionPage.vue'),
      },
      {
        name: 'Preferences',
        path: 'identity',
        component: () =>
          import('@/views/private/account/profile/SubsidiaryPreferences.vue'),
      },
    ],
  },
  {
    name: 'Dashboard',
    path: 'dashboard',
    component: () => import('@/views/private/account/DashboardView.vue'),
  },
  {
    name: 'Users',
    path: 'users',
    component: () => import('@/views/private/account/ManageUsers.vue'),
  },
];
